export default __webpack_public_path__ + "static/media/send.6ac8fff8.svg";